/** Traductions sélecteur de langue (FR / AR) */
export const languageSwitcherFr = {
  labelFr: 'FR',
  labelAr: 'عربي',
  switchToArabic: 'Passer à l\'Arabe',
  switchToFrench: 'Passer au Français'
};

export const languageSwitcherAr = {
  labelFr: 'FR',
  labelAr: 'عربي',
  switchToArabic: 'التبديل إلى العربية',
  switchToFrench: 'التبديل إلى الفرنسية'
};
